<div class="container-fluid p-0">
    <div class="profile-section header">
        <div class="avatar align-self-center " style="width: 70px; height: 70px;">
            <img src="assets/default-user.png" style="height: 100%;width: 100%;    border-radius: 50%;">
        </div>
        <div class="profile-data">
            <h4 class="profile-data__name ellipsize"> {{ user_basic_details.firstName || ''}}
                {{user_basic_details.lastName ||
                ''}} </h4>
            <!-- <div class="profile-data__location ellipsize"> {{resume_details.presentLocation || ''}} </div> -->
            <div class="profile-data__location ellipsize"> {{user_basic_details.mobileIsd || ''}}
                {{user_basic_details.mobileNumber}} </div>
            <div class="profile-data__location ellipsize"> {{user_basic_details.emailId || ''}}
            </div>
        </div>
    </div>
    <div class="split-nav">
        <div class="nav-column">
            <div class="nav-column__section ng-star-inserted">
                <!-- <div class="percent-complete ">
                    <span>
                        {{profile_percentage}}%
                    </span>
                    <span>
                        <mat-progress-bar mode="determinate" [value]="profile_percentage"></mat-progress-bar>
                    </span>
                </div> -->
                <div class="blurb-section">
                    <!-- <div class="blurb-section__title open-change  mb-2">
                        <span class="mr-2">
                            Open for a job change
                        </span>
                        <mat-slide-toggle [(ngModel)]="activeForChange"></mat-slide-toggle>
                    </div> -->

                    <div class="blurb-section__link">
                        <a class="pointer nav-item link" (click)="openRoute(0,'edit-profile')">Update Profile</a>
                        <a (click)="openRoute(0,'my-jobs')" class="nav-item link">Applied Jobs & Status</a>
                    </div>
                </div>
            </div>
            <div class="nav-column__section ng-star-inserted">
                <a class="nav-item mt-2 link" (click)="changePassword()">Password &amp; security</a>
                <a class="nav-item clickable link " (click)="logout()">Logout</a>
            </div>
        </div>
        <div class="nav-column TAL-border-top" *ngIf="false">
            <div class="nav-column__section ng-star-inserted">
                <div class="nav-item column mb-3">
                    <h6 class="referral-code-title mb-0">
                        <span (click)="openExternalLink('https://tal.social/')" class="link mx-1">
                            TAL
                        </span>
                        Token Balance
                    </h6>
                    <h4 class="data-text link "> {{wallet_data && wallet_data.totalTALBalance}} </h4>
                </div>
                <div class="nav-item column">
                    <h6 class=" referral-code-title mb-0  "> Your Referral Code</h6>
                    <h4 class="data-text link" (click)="copyToClipboard()"> {{user_basic_details &&
                        user_basic_details.membershipId}} </h4>
                    <div class="mt-2">
                        <span class="btn btn-sm btn-default  user-action-btn" (click)="copyToClipboard()">
                            <i class="fa fa-copy mx-1"> Copy </i>
                        </span>
                        <span class="btn btn-sm btn-default  user-action-btn " (click)="openMail()">
                            <i class="fa fa-share mx-1"> Share </i>
                        </span>
                    </div>
                </div>

            </div>
            <!-- <div class="nav-column__section ng-star-inserted">
                <h6>TAL Balance</h6>
                <p> 5,468 </p>
            </div> -->
            <!-- <div class="nav-column__section ng-star-inserted"><a href="/members/settings?appRef=header"
                    class="nav-item">Settings &amp; notifications</a><a href="/blog/workers?appRef=header"
                    class="nav-item">Job Search and Career
                    Advice</a>
            </div> -->
        </div>
        <div class="nav-column TAL-wallet" *ngIf=" false &&user_basic_details && user_basic_details.membershipId">
            <div class="nav-column__section ng-star-inserted">
                <p *ngIf="user_basic_details.walletMsg" [innerText]="(user_basic_details.walletMsg | HTMLFormatter)">
                </p>
            </div>

            <!-- <div class="nav-column__section ng-star-inserted">
                <h6>TAL Balance</h6>
                <p> 5,468 </p>
            </div> -->
            <!-- <div class="nav-column__section ng-star-inserted"><a href="/members/settings?appRef=header"
                    class="nav-item">Settings &amp; notifications</a><a href="/blog/workers?appRef=header"
                    class="nav-item">Job Search and Career
                    Advice</a>
            </div> -->
        </div>

    </div>
</div>